import { ActionTree } from 'vuex';
import { NodeSamlSession, NodeSamlState } from './types';
import { RootState } from '../../../types';
import { isHappenedOtherPartyError } from '../../../error-type';
import * as types from './mutation-types';
import ApiUrl from '../../../../api/url';

export const actions: ActionTree<NodeSamlState, RootState> = {
    /**
     * NodeSamlSessionに保存してあるリダイレクト先情報の取得
     * @param commit Vuex変数
     * @param dispatch Vuex変数
     * @param payload guid と セッションID
     * @returns {Promise<void>}
     */
    async acsRedirectData({ commit, dispatch }, payload: { session_id: string; relay_state: string }) {
        try {
            commit(types.ACS_RECIRECT_DATA_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.NodeSaml.ACS_REDIRECT_DATA,
                    params: {
                        session_id: payload.session_id,
                        relay_state: payload.relay_state,
                    },
                },
                { root: true }
            );

            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.ACS_RECIRECT_DATA_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.ACS_RECIRECT_DATA_FAILURE, resData.errors[0]);
        }
    },

    /**
     * データを保存する
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async setData({ commit }, payload: NodeSamlSession) {
        commit(types.SET_DATA, payload);
    },

    /**
     * 保存データを削除する
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearData({ commit }) {
        commit(types.CLEAR_DATA);
    },

    /**
     * 画面切り替え時のstoreの消去
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute() {
        /* 画面切り替え間で保持しておく必要がある */
    },
};
